import React from "react";
import InnerPage from './innerPage.jsx';
import './style.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../../components/header';
import HeaderMembro from '../../components/header3';
import Footer from '../../components/footer';



const PageDocuments = () => {


    return (

        <div>
            <Header></Header>
            <HeaderMembro></HeaderMembro>
            <div className='bg-space'></div>
            <section className="inner-page p-3">
                <InnerPage />
            </section>
            <Footer></Footer>
        </div>
    );
}

export default PageDocuments